import { render, staticRenderFns } from "./Authors.vue?vue&type=template&id=4f6ad876&scoped=true&"
import script from "./Authors.vue?vue&type=script&lang=js&"
export * from "./Authors.vue?vue&type=script&lang=js&"
import style0 from "./Authors.vue?vue&type=style&index=0&id=4f6ad876&scoped=true&lang=scss&"
import style1 from "./Authors.vue?vue&type=style&index=1&id=4f6ad876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ad876",
  null
  
)

export default component.exports